// extracted by mini-css-extract-plugin
export default {"BodyWrapper":"Xffj356-djbxHQhFM4RJpg==","Intelligences":"OQdodr0UB2LDcxOULusd+w==","ProjectResource":"AuRHZbSAV2VIuAjiGJJySw=="};